import { Divider } from 'antd'
import { FC } from 'react'

import { BitazzaModal, BitazzaText } from '../../../../../components'
import Styles from './Chart.module.scss'
import { useTranslation } from 'react-i18next'

interface Props {
    isModalOpen: boolean
    onCLoseModal: () => void
}

export const PerformanceIndexModal: FC<Props> = ({
    isModalOpen,
    onCLoseModal,
}) => {
    const { t } = useTranslation()
    return (
        <BitazzaModal
            size="260px"
            onCancel={onCLoseModal}
            isModalOpen={isModalOpen}
            footer={
                <div className={Styles.button} onClick={onCLoseModal}>
                    <BitazzaText
                        format="t18"
                        color="#FFF"
                        content={t('txt_close')}
                        bold
                    />
                </div>
            }
        >
            <div className={Styles.containerModal}>
                <div className={Styles.wrapperModal}>
                    <BitazzaText
                        format="t24"
                        color="#FFFFFF"
                        lineHeight={31}
                        content={t('txt_performance_index_title')}
                        bold
                    />
                    <Divider className={Styles.divider} />
                    <BitazzaText
                        format="t16"
                        color="#86A1A1"
                        content={t('txt_performance_index_des_1')}
                        bold
                    />
                    <Divider className={Styles.dividerText} />

                    {/* <BitazzaText
                        format="t16"
                        color="#86A1A1"
                        content="By providing this index, Bitazza Trading Simulator enables traders to evaluate their performance over time and make informed decisions about their investment strategies. By leveling the playing field and providing a metric that reflects true trading ability, users can focus on improving their performance and achieving their financial goals."
                        bold
                    /> */}
                </div>
            </div>
            <Divider className={Styles.dividerText} />
        </BitazzaModal>
    )
}
